import React from "react";
import Icon from "./Icon";
import "../css/PrivateParty.css";

export default function PrivatePartyOffer({ headingId }) {
  return (
    <section className="private-party-offer" aria-label="Party pricing promise">
      <span className="private-party-offer-icon" aria-hidden="true">
        <Icon name="sparkle" />
      </span>
      <div className="private-party-offer-copy">
        <h2 id={headingId}>No service fees.</h2>
        <p className="private-party-offer-tax">
          <strong>10.25% tax applies.</strong> Optional add-ons priced
          separately.
        </p>
        <p>
          Private parties, weekday celebrations, rentals, extra guests, and
          every add-on. More room in your budget for the celebration.
        </p>
      </div>
    </section>
  );
}
